import Model, { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { formattedToReadable } from 'uplisting-frontend/utils/string';

export default class CustomPropertyAttributeModel extends Model {
  @attr('string') name!: string;
  @attr('string') description!: string;

  @hasMany('custom-property-attribute-value', {
    inverse: 'customPropertyAttribute',
    async: false,
  })
  customPropertyAttributeValues!: ModelRegistry['custom-property-attribute-value'][];

  @cached
  get tagCode(): string {
    return `{{{${this.name}}}}`;
  }

  @cached
  get isPersisted(): boolean {
    return !!this.id;
  }

  @cached
  get order(): number {
    if (!this.isPersisted) {
      return 0;
    }

    return Number(this.id);
  }

  @cached
  get customValue():
    | ModelRegistry['custom-property-attribute-value']
    | undefined {
    return this.customPropertyAttributeValues[0];
  }

  @cached
  get readable(): string {
    return formattedToReadable(this.name);
  }

  @cached
  get namePrettified(): string {
    return this.name.replaceAll('_', ' ');
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'custom-property-attribute': CustomPropertyAttributeModel;
  }
}
